const removeTrailingSpaces = (s: string): string => {
  const MoreThanTwoTrailingSpacesInRow = /\s\s+/g;
  return s.replace(MoreThanTwoTrailingSpacesInRow, ' ').trim();
};

export default removeTrailingSpaces;
